import layout from '@/layout/index.vue'

export default {
  path: '/operation',
  component: layout,
  redirect: '/operation/operation_group',
  name: 'operation',
  meta: {
    title: '店铺运营记录',
    icon: 'account'
  },
  children: [
    {
      path: '/operation/operation_group',
      name: 'operation_group',
      component: () => import('@/views/operation/operation_group/index.vue'),
      meta: {
        title: '分组',
        icon: 'account'
      }
    },
    {
      path: '/operation/operations',
      name: 'operations',
      component: () => import('@/views/operation/operations/index.vue'),
      meta: {
        title: '店铺运营记录',
        icon: 'account'
      }
    }
  ]
}
